<!--
 * @Description:
 * @Author: Aimee·Zhang
 * @Date: 2020-10-23 16:52:20
 * @LastEditors: Aimee·Zhang
 * @LastEditTime: 2022-01-26 14:38:21
-->
<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
export default {
    name: "App",
};
</script>

<style>
@import url("./assets/css/reset.css");
@import url("./assets/css/base.css");
#app {
    font-family: "Microsoft YaHei" !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    font-weight: normal;
    width: 100%;
    height: 100%;
}
html {
    /* background-image: linear-gradient(to bottom, #150060 0%, #6320a5 100%); */
    width: 100%;
    height: 100%;
    /* background-color: #01233c; *//* 北京投票背景色 */
    /* background-image: url(assets/images/icon_list_bg_2.png); 换了送背景色 笔墨山河背景色  */
    background-color: rgba(179, 243, 195, 0.2);
    background-repeat: repeat-x repeat-y;
}
body {
    /* padding: 15px; */
    font-family: "Microsoft YaHei" !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue